import { useMemo } from 'react';
import { v4 as uuidv4 } from 'uuid';
const WithRandomFormId = (props: { children: (props: { id: string }) => JSX.Element }) => {
    const id = useMemo(() => uuidv4(), []);
    return props.children({
        id,
    });
};
export default WithRandomFormId;
